import Vue from 'vue'
import Vuex from 'vuex'
import config from './modules/config';
import projects from './modules/projects';
import user from './modules/user';
import components from './modules/components';
import apps from './modules/apps';
import widgets from './modules/widgets';
import events from './modules/events';
import media from './modules/media';
import documents from './modules/documents';
import server from './modules/server';
import subscription from './modules/subscription';
import integrations from './modules/integrations';
import onboarding from './modules/onboarding';
import satellites from './modules/satellites';
import resources from './modules/resources';
import tutorials from './modules/tutorials';
import coldStorage from './modules/coldStorage';
import fields from './modules/fields'
import console from './modules/console'
import cortex from './modules/kortex'
import spark from './modules/spark'
import ocrModels from './modules/ocrModels'
import http from "../shared/http"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    config,
    projects,
    user,
    components,
    apps,
    widgets,
    events,
    media,
    documents,
    server,
    subscription,
    integrations,
    satellites,
    tutorials,
    resources,
    coldStorage,
    fields,
    onboarding,
    console,
    cortex,
    spark,
    ocrModels
  },
  state: {
    currentProjectUUID: localStorage.getItem("current_project_uuid"),
    currentWorkspaceUUID: localStorage.getItem("current_workspace_uuid"),
    currentProject: null,
    currentWorkspace: null,
    currentEnv: localStorage.getItem("current_env"),
    currentTheme: localStorage.getItem("current_theme"),
    containerKey: 1,
    breadcrumbs: [],
    currencyRates: null,
    currentContext: localStorage.getItem('current_context'),
  },
  actions: {
    setCurrentEnv({commit}, env) {
      return new Promise((resolve, reject) => {
        if (env != localStorage.getItem("current_env")) {
          localStorage.setItem("current_env", env)
          commit('SET_CURRENT_ENV', env)
          resolve(env)
        }
      })
    },

    setCurrentTheme({commit}, theme) {
      return new Promise((resolve, reject) => {
        if (theme !== localStorage.getItem("current_theme")) {
          localStorage.setItem("current_theme", theme)
          commit('SET_CURRENT_THEME', theme)
          resolve(theme)
        }
      })
    },

    setWorkspace({commit}, workspace) {
      return new Promise((resolve, reject) => {
          commit('SET_CURRENT_WORKSPACE', workspace)
          resolve(workspace)
      })
    },

    refreshState({commit}) {
      commit('SET_PERMISSIONS', null)
      commit('SET_ROLES', [])
      commit('SET_INTEGRATIONS', null)
      commit('SET_WORKFLOWS', [])
      commit('SET_WORKFLOWS_LOADED', false)
      commit('SET_APPS', null)
      commit('SET_TRIALS', null)
      commit('SET_SUBSCRIPTIONS', null)
      commit('CLEAR_BREADCRUMBS')
      commit('SET_PROJECT_INFO', null)
      commit('SET_FORGE_APPS', null)
    },

    fetchCurrencyRates({commit}, currency) {
      this._vm.$transactions.getCurrencyRates(currency).then(resp => {
        commit("SET_CURRENCY_RATES", { [currency.toLowerCase()]: resp.data })
      })
    }
  },
  mutations: {
    SET_CURRENT_ENV(state, env) {
      state.currentEnv = env
    },

    SET_CURRENT_THEME(state, theme) {
      state.currentTheme = theme
    },

    RELOAD_CONTAINER(state) {
      state.containerKey++
    },

    BREADCRUMB(state, route) {
      let exist = state.breadcrumbs.find(f => {
          return f.meta.label == route.meta.label
      })

      if (exist) {
        state.breadcrumbs = state.breadcrumbs.filter(b => {
          return b.meta.label != exist.meta.label
        })
      }

      if (state.breadcrumbs.length > 4) {
        state.breadcrumbs.splice(0, 1)
      }
      state.breadcrumbs.push(route)
    },

    CLEAR_BREADCRUMBS(state) {
      state.breadcrumbs = []
    },

    SET_CURRENCY_RATES(state, data) {
      state.currencyRates = data
    },

    SET_CURRENT_CONTEXT(state, ctx) {
      localStorage.setItem("current_context", ctx)
      state.currentContext = ctx
    }
  },
  getters: {
    isLiveEnv(state) {
      return (state.currentEnv && state.currentEnv == 'live') ? true : false
    },

    getCurrentEnv(state) {
      return state.currentEnv ? state.currentEnv : 'live';
    },

    getCurrentTheme(state) {
      return state.currentTheme ? state.currentTheme : 'dark';
    },

    isRunModePlatform() {
      return localStorage.getItem("run_mode") == "platform"
    },

    httpClient() {
      return http
    },

    containerKey(state) {
      return state.containerKey
    },

    getBreadcrumbs(state) {
      return state.breadcrumbs
    },

    getCurrencyRates(state) {
      return state.currencyRates
    },

    getCurrentContext(state) {
      return state.currentContext
    }
  }
})